import React from "react";
import { Avatar, AvatarGroup, Box, Stack, Typography } from "@mui/material";

import { DealStageItem, UserLight } from "store/types";
import { useNavigate } from "hooks";
import { TooltipDiv } from "components/tooltips/TooltipDiv";
import { useAllowDealTabOpenSelector } from "store";
import { NavigateLink } from "components/Navigate-link/NavigateLink";

import { getAssetClassName } from "../Pipeline/pipeline-utils";

interface Props extends DealStageItem {}

export const SharedDealCard: React.FC<Props> = ({ id, title, asset_class, shared_with, role }) => {
  const allowNewTab = useAllowDealTabOpenSelector();
  const navigate = useNavigate();

  return (
    <NavigateLink allowNewTab={allowNewTab} route="deal" params={{ deal_id: String(id) }}> 
    <div
      onClick={() => navigate({ route: "deal", params: { deal_id: id } })}
      style={{
        userSelect: "none",
        WebkitUserSelect: "none",
        msUserSelect: "none",
        MozUserSelect: "none",
        cursor: "grab"
      }}
    >
      <Stack
        sx={{
          borderRadius: "8px",
          bgcolor: "#FBE3D3",
          p: "8px",
          flexGrow: 1,
          justifyContent: "space-between",
          gap: "12px",
          userSelect: "none",
          WebkitUserSelect: "none",
          msUserSelect: "none",
          MozUserSelect: "none",
          "&:active": {
            cursor: "grabbing"
          },
          "& *": {
            userSelect: "none",
            WebkitUserSelect: "none",
            msUserSelect: "none",
            MozUserSelect: "none"
          }
        }}
      >
        <Stack>
          <Typography sx={{ fontSize: "16px", lineHeight: "24px", fontWeight: 400 }}>{title}</Typography>
          <Typography sx={{ fontSize: "14px", lineHeight: "16px", color: "#496682" }}>
            {getAssetClassName(asset_class)}
          </Typography>
        </Stack>
        <Stack direction="row" sx={{ justifyContent: "space-between" }}>
          <Typography
            sx={{
              fontSize: "12px",
              color: "#496682",
              lineHeight: "16px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {role?.presentation_name}
          </Typography>
          <AvatarGroup
            sx={{
              "& .MuiAvatar-root": { width: 20, height: 20, fontSize: 12, padding: 0 }
            }}
            max={3}
          >
            {shared_with.length &&
              shared_with.map((share: UserLight) => (
                <Box key={share.id}>
                  <TooltipDiv place="bottom" tooltipMessage={share.full_name}>
                    <Avatar src={share.profile_photo_url} />
                  </TooltipDiv>
                </Box>
              ))}
          </AvatarGroup>
        </Stack>
      </Stack>
    </div>
    </NavigateLink>
  );
};
